@if (item.externalUrl) {
  <a
    tabindex="-1"
    mat-list-item
    class="menu-list-item d-flex align-items-center text-decoration-none"
    target="_blank"
    rel="noopener noreferrer"
    [href]="item.externalUrl"
    [ngClass]="{
      first: first,
      close: !isOpen,
      'light-mode': !darkMode && !isAr,
      'dark-mode': darkMode && !isAr,
      'ar-mode': isAr,
      'min-width-200': isOpen,
      'min-width-auto': !isOpen,
    }"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>
} @else {
  <a
    tabindex="-1"
    mat-list-item
    routerLinkActive
    class="menu-list-item d-flex align-items-center text-decoration-none is-navigate-grid-outside-click"
    #rla="routerLinkActive"
    [routerLink]="!item.disabled ? item.route : null"
    [class.disabled]="item.disabled"
    [ngClass]="{
      active: rla.isActive && !item.disabled,
      first: first,
      close: !isOpen,
      'light-mode': !darkMode && !isAr,
      'dark-mode': darkMode && !isAr,
      'ar-mode': isAr,
      'min-width-200': isOpen,
      'min-width-auto': !isOpen,
    }"
    (click)="onItemSelected(item)"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>
}

<ng-template #itemContent>
  @if (item.iconName) {
    <svg class="menu-item-img">
      <use [attr.xlink:href]="'./assets/icons/sidenav/' + item.iconName + '.svg'"></use>
    </svg>
  }

  <span class="menu-name fw-medium">{{ item.displayName | translate }}</span>
</ng-template>
